export enum PrismModule {
    Admin = 'admin',
    Plastics = 'plastics',
    Automation = 'automation',
    Settings = 'settings',
    Metals = 'metals',
    PrismCommon = 'common',
    C3 = 'c3',
    InjectionMolding = 'injection-molding',
    Printing3d = '3d-printing',
}

export enum PrismCommonSubModule {
    Resources = 'resources',
    Procedures = 'procedures',
    Assets = 'assets',
    Meetings = 'meetings',
    FreightCarriers = 'freight-carriers',
    Customer = 'customers',
    Vendor = 'vendors',
    PurchaseRequests = 'purchase-requests',
    Purchasing = 'purchasing',
    PurchaseRequestReceiving = 'purchase-request-receiving',
    PurchasingDashboard = 'purchasing-dashboard',
    Contacts = 'contacts',
    SoftwareRequests = 'software-requests',
    Maintenance = 'maintenance',
    SmartJeff = 'smart-jeff',
    Projects = 'projects',
    PrismCommonReporting = 'prism-common-reporting',
    EmailGroups = 'email-groups',
    DirectMessages = 'direct-messages',
    Finance = 'finance',
    HumanResources = 'human-resources',
    UpsShipments = 'ups-shipments',
    Capitalization = 'capitalization',
    MoveRequests = 'move-requests',
}

export enum PlasticsSubModule {
    Invoices = 'invoices',
    Orders = 'orders',
    OrderReview = 'order-review',
    Product = 'products',
    HardwareItem = 'hardware-items',
    Fixture = 'fixtures',
    Materials = 'materials',
    RotoSchedule = 'roto-schedule',
    ProductionManager = 'production-manager',
    TaskSearch = 'task-search',
    PlasticsFinishingSchedule = 'plastics-finishing-schedule',
    PlasticsFinishingStation = 'plastics-finishing-station',
    RotoMachineOperation = 'roto-machine-operation',
    MaterialMixing = 'material-mixing',
    MaterialMixingStation = 'material-mixing-station',
    RotoSupervisor = 'roto-supervisor',
    QualityControl = 'quality-control',
    QualityInspector = 'quality-inspector',
    PlasticsScrap = 'plastics-scrap',
    PlasticsScrapDocumenting = 'plastics-scrap-documenting',
    PlasticsReporting = 'plastics-reporting',
    PlasticsCalendar = 'plastics-calendar',
    ComplaintLog = 'complaint-log',
    PlasticsShipping = 'plastics-shipping',
    ShippingManager = 'shipping-manager',
    Forecasting = 'forecasting',
    Molds = 'molds',
    MoldCheckups = 'mold-checkups',
    GroceryStore = 'grocery-store',
    PlasticsStaticLabel = 'plastics-static-label',
    Inventory = "inventory",
    InventoryManager = "inventory-manager",
    Settings = "settings",
    Suncast = "suncast",
    Clack = "clack",
    Motionmaster = "motionmaster",
    Kolorcans = "kolorcans",
    Quoting = "quoting",
    Pricing = "pricing",
    PlasticsC3Coolers = 'plastics-c3-coolers',
    MoldRepairRequests = 'mold-repair-requests',
    CustomerProcesses = 'customer-processes',
    HotList = 'hot-list',
    Metrics = 'metrics',
    QuoteStudio = 'quote-studio',
}

export enum AutomationSubModule {
    FactoryNode = 'factory-node',
    Trends = 'trends',
    RobotProgramming = 'robot-programming',
    ClientDevices = 'client-devices',
    Dashboards = 'dashboards',
    SoftwareTasks = 'software-tasks',
    TimeTracker = 'time-tracker',
    LabelPrinting = 'label-printing',
    EngineeringUpdateMeeting = 'engineering-update-meeting',
    KnowledgeBase = 'knowledge-base',
    InstructionManual = 'instruction-manual',
    Schematics = 'schematics',
    AutomationHardwareItem = 'automation-hardware-items',
    EngineeringProjects = 'engineering-projects',
    EngineeringProjectFiles = 'engineering-project-files',
}

export enum AdminSubModule {
    ManageUsers = 'manage-users',
    OnsiteUtilities = 'onsite-utilities',
    Utilities = 'utilities',
    LabelPrinterGroups = 'label-printer-groups',
    CronJobs = 'cron-jobs',
    Migrations = 'migrations',
    Collections = 'collections',
    SvgPreview = 'svg-preview',
    UserAbilitiesGrid = 'user-abilities-grid',
    Cribbage = 'cribbage',
    DataserverManagement = 'dataserver-management',
}

export enum SettingsSubModule {
    ChangeLog = 'change-log',
    Display = 'display',
    BuildInfo = 'build-info',
}
export enum MetalsSubModule {
    ObsessedEngineering = 'obsessed-engineering',
    LaserProgramming = 'laser-programming',
    LaserOperator = 'laser-operator',
    LaserScheduling = 'laser-scheduling',
    MetalsHardwareItem = 'metals-hardware-items',
    Products = 'products',
    Project = 'project',
    MetalsTagGenerator = 'metals-tag-generator',
    MetalsTools = 'metals-tools',
    Metaltrack = 'metaltrack',
    Settings = 'settings',
    ProcessStation = 'process-station',
    ProductionSchedule = "production-schedule",
    Orders = "orders",
    ProductionManager = "production-manager",
    MetalsQuoteRequest = "metals-quote-request",
    CadViewer = 'cad-viewer',
    SheetMetalStudio = 'sheet-metal-studio',
    Quoting = 'quoting',
    AssemblyQuoting = 'assembly-quoting',
    ToolRoom = 'tool-room',
    ProductSetups = 'product-setups',
    ToolRoomMachines = 'tool-room-machines',
    Inventory = 'inventory',
}

export enum C3SubModule {
    C3Orders = 'orders',
    C3Product = 'c3-product',
    C3HardwareItem = 'c3-hardware-item',
    C3Inventory = 'c3-inventory',
    C3MoldedBodyCount = 'c3-molded-body-count',
    C3Assembly = 'c3-assembly',
    C3StockLimits = 'c3-stock-limits',
    C3Reporting = 'c3-reporting',
    StickerStudio = 'sticker-studio',
    C3Rider = 'c3-rider',
    C3ClearanceInventory = 'c3-clearance-inventory',
    C3Graphics = 'graphics',
}

export enum InjectionMoldingSubModule {
    Orders = 'orders',
    Products = 'products',
    HardwareItems = 'hardware-items',
    Materials = 'materials',
    QualityControl = 'quality-control',
    Molds = 'molds',
}

export enum Printing3dSubModule {
    Products = 'products',
}

export enum HumanResourcesSubModule {
    Vacation = 'vacation',
    Employees = 'employees',
}

const MODULE_DISPLAY_OVERRIDES: Record<string, string> = {
    '3d-printing': '3D Printing',
};

const SUB_MODULE_DISPLAY_OVERRIDES: Record<string, string> = {
    'svg-preview': 'SVG Preview',
    'sticker-studio': 'Sticker Studio',
    'c3-stock-limits': 'Stock Limits',
    'c3-assembly': 'Assembly',
    'c3-reporting': 'Reporting',
    'c3-clearance-inventory': 'Clearance Inventory',
    'graphics': 'Graphics',
    'dxf-viewer': 'DXF Viewer',
    'direct-messages': 'Direct Messages',
    'move-requests': 'Move Requests',
    'cad-viewer': 'CAD Viewer',
    'obsessed-engineering': 'Obsessed Engineering',
    'sheet-metal-studio': 'Sheet Metal Studio',
    'bill-of-materials': 'Bill of Materials',
};

export function toDisplayName(value: string): string {
    if (MODULE_DISPLAY_OVERRIDES[value]) return MODULE_DISPLAY_OVERRIDES[value];
    if (SUB_MODULE_DISPLAY_OVERRIDES[value]) return SUB_MODULE_DISPLAY_OVERRIDES[value];
    return value
        .split('-')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
}
